import Continue from '../continue';
import CancelOrder from '../cancelOrder';
import ReturnToSales from '../returnToSales';
import Locked from '../Locked';

export const salesRep = {
  Incomplete: [Continue, CancelOrder],
  Submitted: [Locked]
};

export const admin = {
  Incomplete: [Continue, CancelOrder],
  Submitted: [Continue, ReturnToSales, CancelOrder]
};
